import { useEffect, useRef, useState } from "react";

export function PortfolioThemeControl() {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [reduced, setReduced] = useState(false);
  const [status, setStatus] = useState("음악은 꺼져 있어요. 원할 때만 재생됩니다.");

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const apply = () => {
      setReduced(media.matches);
      if (media.matches) {
        audioRef.current?.pause();
        setPlaying(false);
        setStatus("기기의 동작 줄이기 설정에 따라 음악을 멈췄어요.");
      } else {
        setStatus("음악은 꺼져 있어요. 원할 때만 재생됩니다.");
      }
    };
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, []);

  const togglePlayback = async () => {
    const audio = audioRef.current;
    if (!audio || reduced) return;
    if (audio.paused) {
      try {
        await audio.play();
        setPlaying(true);
        setStatus("프로젝트 준비 음악 재생 중");
      } catch {
        setStatus("음악을 재생하지 못했어요. 다시 눌러 주세요.");
      }
    } else {
      audio.pause();
      setPlaying(false);
      setStatus("프로젝트 준비 음악 일시정지");
    }
  };

  const toggleMute = () => {
    const audio = audioRef.current;
    if (!audio || reduced) return;
    audio.muted = !audio.muted;
    setMuted(audio.muted);
    setStatus(audio.muted ? "음악 소리 끔" : playing ? "프로젝트 준비 음악 재생 중" : "음악 소리 켬");
  };

  return (
    <section className="portfolio-theme-control" aria-labelledby="portfolio-theme-title">
      <div>
        <span className="ticket-code">45초 준비 음악</span>
        <h3 id="portfolio-theme-title">준비표를 확인한 뒤 잠깐 들어보세요.</h3>
        <p>자동 재생되지 않고, 음악 없이도 모든 준비 작업을 끝낼 수 있어요.</p>
      </div>
      <audio ref={audioRef} src="/audio/portfolio-theme.mp3" preload="none" onEnded={() => { setPlaying(false); setStatus("45초 음악 재생 완료"); }} />
      <div className="portfolio-theme-actions">
        <button className="button secondary" type="button" disabled={reduced} aria-pressed={playing} onClick={() => void togglePlayback()}>{playing ? "음악 일시정지" : "45초 음악 듣기"}</button>
        <button className="button text" type="button" disabled={reduced} aria-pressed={muted} onClick={toggleMute}>{muted ? "소리 켜기" : "소리 끄기"}</button>
      </div>
      <span className="portfolio-theme-status" role="status" aria-live="polite">{status}</span>
    </section>
  );
}
